/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 16.06.17.
 */

import BaseFormatter from "./BaseFormatter";

class ValueTestFormatter extends BaseFormatter {
    isTestTrue(value) {
        if (!this.params || this.params.length < 1) return false;

        switch (this.params[0]) {
            case "null":
                if (value == null) return true;
                break;
            default:
                break;
        }
        return false;
    }

    format(value) {
        if (!this.params || this.params.length < 1) return "";
        let trueValue = this.params[1];
        let falseValue = (this.params[2] ? this.params[2] : "");
        return (this.isTestTrue(value) ? trueValue : falseValue);
    }
}

export default ValueTestFormatter;
